
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class ChooseLayerToCopyModal extends Vue {

    @Prop() layerList: OM.LayerComposition[];
    @Prop() rawMaterialTransportPhases: { [key: string]: OM.TransportProductionPhase[]; };
    @Prop() productionPhase: string;
    @Prop() layer: OM.LayerComposition;

    @Prop() saveCallback: (selectedLayersToCopyInto: string) => void;

    selectedLayersToCopyInto: string = "";

    created() {}

    get disabled() {
        return !this.selectedLayersToCopyInto;
    }

    save() {
        this.saveCallback(this.selectedLayersToCopyInto);
    }
}
